import React from 'react';

import ElapsedTime from 'app/components/general/ElapsedTime';
import {MainStatusCard} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal/MainStatusCard';
import {getCommonDocument} from 'app/components/general/GenericDocumentActionButtons/SignoffRequestModal/utils';
import {getUserLink} from 'app/general/dashboards/ItemLastActivity';
import {gt} from 'app/utils/i18n';

import type {BaseActionableDocumentType} from 'app/general/types';

type Props = {
  isLoading: boolean;
  document: BaseActionableDocumentType;
  disabled: boolean;
};

export function StatusPanel({isLoading, document, disabled}: Props) {
  if (isLoading) {
    return null;
  }

  const commonDocument = getCommonDocument(document);

  if (disabled) {
    return (
      <MainStatusCard
        color="warning"
        iconClasses="fa-exclamation-triangle "
        mainMessage={
          commonDocument.team_memberships.length > 0
            ? '%(document)s is not attached to any team with Sign Offs'
            : '%(document)s is not attached to any team'
        }
        document={document}
        additionalContent={
          <div className="small text-secondary mt-2">
            {gt('To request Sign Off by team for this document:')}
            <ul>
              <li>
                {gt('Add it to a team that has Sign Off rules configured')}{' '}
              </li>
              <li>
                {gt('Enable "When managers choose" in team\'s Sign Off rules')}
              </li>
            </ul>
          </div>
        }
      />
    );
  }

  if (
    commonDocument.signoff_requested_by != null &&
    commonDocument.signoff_requested_at != null
  ) {
    const user = getUserLink(commonDocument.signoff_requested_by);
    return (
      <MainStatusCard
        color="success"
        iconClasses="fa-check-circle"
        mainMessage="Sign Off required already for this version of %(document)s"
        document={document}
        additionalContent={
          <ElapsedTime
            timestamp={commonDocument.signoff_requested_at}
            ContainerTag="small"
            className="d-block mt-2 text-secondary"
            wrapTextFn={(timeago) =>
              gt('%(timeago)s by %(user)s', {
                timeago,
                user,
              })
            }
          />
        }
      />
    );
  }

  return (
    <MainStatusCard
      color="info"
      iconClasses="fa-check-circle"
      mainMessage="No Sign Off required yet for this version of %(document)s"
      document={document}
    />
  );
}
